import { atom } from "recoil";

export const updateUserFinancialDetailsDrawerState = atom({
  key: "updateUserFinancialDetailsDrawerState", // unique ID (with respect to other atoms/selectors)
  default: null, // default value (aka initial value)
});
